var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i',{staticClass:"fa",class:{'fa-shopping-cart': this.isValid, 'fa-exclamation-triangle': !this.isValid}})])
}
var staticRenderFns = []

export { render, staticRenderFns }